<div *ngIf="messageService.messages.length"> 
  <div  class="messageField"> 
    <div *ngFor='let message of messageService.messages'> {{message}} </div> 
  </div> 
</div> 